// extracted by mini-css-extract-plugin
export default {"noOptionText":"NoOptionText_noOptionText__Z075x"};